var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon5 = function SvgIcon5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 38c8.837 0 16-7.163 16-16S50.837 6 42 6s-16 7.163-16 16 7.163 16 16 16Zm11.325-4.675-22.65-22.65M25 39l-3 3",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2 24.475 7.025 50.625a1.975 1.975 0 0 0 .2 2.6l3.55 3.55a1.975 1.975 0 0 0 2.6.2L39.525 37.8",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcon5;